import { createContext, useContext, useEffect, useRef, useState, useCallback } from "react";
import { useAuth } from "./auth";
import { getToken } from "./api";

const RtCtx = createContext({ subscribe: () => () => {}, lastNotification: null });

export function RealtimeProvider({ children }) {
  const { user } = useAuth();
  const subsRef = useRef(new Set());
  const [lastNotification, setLastNotification] = useState(null);
  const esRef = useRef(null);

  const subscribe = useCallback((fn) => {
    subsRef.current.add(fn);
    return () => subsRef.current.delete(fn);
  }, []);

  useEffect(() => {
    if (!user) return;
    const token = getToken();
    if (!token) return;
    const base = process.env.REACT_APP_BACKEND_URL;
    const url = `${base}/api/stream?token=${encodeURIComponent(token)}`;
    const es = new EventSource(url);
    esRef.current = es;
    es.onmessage = (ev) => {
      try {
        const msg = JSON.parse(ev.data);
        if (msg.type === "notification") setLastNotification(msg.data);
        subsRef.current.forEach((fn) => { try { fn(msg); } catch {} });
      } catch {}
    };
    es.onerror = () => { /* browser auto-retries */ };
    return () => { try { es.close(); } catch {} };
  }, [user?.id]);

  return <RtCtx.Provider value={{ subscribe, lastNotification }}>{children}</RtCtx.Provider>;
}

export function useRealtime() { return useContext(RtCtx); }
